import { PoolFormattedMessage } from '@synergy/components-next';
import { ReactElement } from 'react';
import { SearchIcon } from '@synergy/theme-next';
import { Stack } from '@mui/material';

import { EmptyState } from '../../../components/empty-state/empty-state';
import { EmptyStateContent } from '../../../components/empty-state/empty-state-content';
import { EmptyStateTitle } from '../../../components/empty-state/empty-state-title';

export const SearchPageEmptySearchparams = (): ReactElement => {
    return (
        <Stack sx={{ pt: 10, margin: 'auto' }}>
            <EmptyState icon={<SearchIcon fontSize="inherit" />}>
                <EmptyStateTitle>
                    <PoolFormattedMessage id="app.empty.searchparams.title" />
                </EmptyStateTitle>
                <EmptyStateContent>
                    <PoolFormattedMessage id="app.empty.searchparams.content" />
                </EmptyStateContent>
            </EmptyState>
        </Stack>
    );
};
